import React, { Component } from "react"
import TableGestoresTrash from "./TableGestoresTrash"
import Layout from "../Layout"
import { Loading, HttpError } from "../../components"
import * as ApiHelper from "../../ApiHelper"
export default class GestoresTrash extends Component {
  constructor() {
    super()
    this.getGestores = this.getGestores.bind(this)
    this.didRestore = this.didRestore.bind(this)
    this.filter = this.filter.bind(this)
    this.state = { gestores: [], initialGestores: [], showTable: false }
  }
  componentWillMount() {
    this.getGestores()
  }
  getGestores() {
    ApiHelper.getGestoresTrash((gestores, error) => {
      if (gestores) {
        this.setState({
          gestores: gestores,
          initialGestores: gestores,
          showTable: true
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialGestores.filter(gestor => {
      return (
        gestor.nome.toLowerCase().search(searchText) !== -1 ||
        gestor.cpf.toLowerCase().search(searchText) !== -1 ||
        gestor.email.toLowerCase().search(searchText) !== -1 ||
        gestor.portaria.toLowerCase().search(searchText) !== -1
      )
    })
    this.setState({
      gestores: filtered
    })
  }
  didRestore() {
    this.getGestores()
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Gestores de contrato">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Gestores de contrato">
        {this.state.showTable ? (
          <TableGestoresTrash
            filter={this.filter}
            onRestore={this.didRestore}
            sizeClass=""
            title={"Gestores de contrato deletados"}
            subtitle={"Listagem de todas os gestores de contrato deletados"}
            backgroundColor="as-blue"
            rows={this.state.gestores}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/gestores/GestoresTrash.js